import { FC } from "react";
import { DatePicker } from "common/components/DatePicker/DatePicker";
import { Tabs } from "common/components/Tabs/Tabs";
import { IconInput } from "common/components/Input/IconInput";
import { SvgLoupe } from "assets/icons/SvgLoupe";
import { PERIOD } from "common/utils/consts";

export const PERIOD_TABS = [
  { label: "Сегодня", value: PERIOD.TODAY },
  { label: "Неделя", value: PERIOD.WEEK },
  { label: "Месяц", value: PERIOD.MONTH },
  { label: "Квартал", value: PERIOD.QUARTER },
  { label: "Год", value: PERIOD.YEAR },
];

interface IReportToolbarProps {
  period?: number;
  onPeriodChange?: (period: number) => void;
  onDateFromChange?: (date: Nullable<Date>) => void;
  onDateToChange?: (date: Nullable<Date>) => void;
  search?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
}

// Панель фильтров отчёта: поиск (если передан), вкладки периода и диапазон дат
export const ReportToolbar: FC<IReportToolbarProps> = ({
  period,
  onPeriodChange,
  onDateFromChange,
  onDateToChange,
  search,
  onSearchChange,
  searchPlaceholder = "Поиск",
}) => {
  const showPeriod = !!onPeriodChange;
  const showDates = !!onDateFromChange;

  return (
    <div className="flex items-center gap-[15px]">
      {onSearchChange && (
        <IconInput
          className="h-[35px] w-full"
          placeholder={searchPlaceholder}
          icon={<SvgLoupe className="h-[15px] w-[15px] text-gray" />}
          value={search ?? ""}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      )}
      {showPeriod && (
        <div className="h-[35px]">
          <Tabs
            className="h-full"
            tabs={PERIOD_TABS}
            value={period}
            onTabClick={onPeriodChange}
          />
        </div>
      )}
      {showDates && (
        <div>
          <DatePicker
            className="h-[35px] w-[240px]"
            onStartDateChange={onDateFromChange}
            onEndDateChange={onDateToChange}
            placeholderText="Введите промежуток дат"
            isClearable={true}
          />
        </div>
      )}
    </div>
  );
};
